import styled from '@emotion/styled'

const DateContainer = styled.div`
  padding-top: 8px;
  text-align: center;
`

export default DateContainer
